import { Config } from './index';
import baseConfig from './base-config';

const config: Config = {
  ...baseConfig,
  api: 'https://global-mr-prd.gd-commerce-services.net',
  brandName: 'Morphy Richards',
  country: '',
  supportedCountries: [],
  commercetools: {
    projectKey: 'global-mr-prd',
    clientId: '',
    clientSecret: '',
    store: '',
  },
  currency: '',
  googleMerchantId: 'BCR2DN6T3OBOFRAY',
  paymentMethods: {
    applePay: true,
    googlePay: true,
    paypal: true,
  },
  theme: 'morphy-richards',
  urls: {
    basket: '/basket',
    checkout: '/checkout',
    confirmation: '/confirmation',
    getInTouch: '/someUrl',
    privacyPolicy: '/someUrl',
    shippingAndReturns: '/someUrl',
    termsConditions: '/someUrl',
    catalog: '/shop',
    retailer: '',
    upsellOverview: '',
  },
  showCrossSellCta: true,
  countryMapping: {
    GB: {
      currency: 'GBP',
      supportedCountries: ['GB'],
      commercetools: {
        store: 'GB',
        clientId: '78SL64ArycK3YALEl2zLgPh_',
        clientSecret: 'm7STxfkvjkrbW1BN5OaPBIu25orlHB7B',
        projectKey: 'global-mr-prd',
      },
      features: {
        ...baseConfig.features,
        enableCartOptimisticResponse: true,
        displayLinkToPDP: true,
        marketingOptInExplicit: true,
        crossSelling: true,
      },
    },
    DE: {
      currency: 'EUR',
      supportedCountries: ['DE'],
      commercetools: {
        store: 'DE',
        clientId: 'wI7cfQTOz0v4nyplZZTMBaQr',
        clientSecret: 'ksgd76hurC-jiH4EczbfV8I3nEaG5OLi',
        projectKey: 'global-mr-prd',
      },
      features: {
        ...baseConfig.features,
        enableCartOptimisticResponse: true,
        displayLinkToPDP: true,
        crossSelling: true,
      },
    },
    FR: {
      currency: 'EUR',
      supportedCountries: ['FR'],
      commercetools: {
        store: 'FR',
        clientId: 'f5drN7ClZi7o9_h2iYg4qAOj',
        clientSecret: 'DVdKEePJxHSgDCH0IDy500SmL3DffGkE',
        projectKey: 'global-mr-prd',
      },
      features: {
        ...baseConfig.features,
        enableCartOptimisticResponse: true,
        displayLinkToPDP: true,
        crossSelling: true,
      },
    },
    RO: {
      currency: 'RON',
      supportedCountries: ['RO'],
      commercetools: {
        store: 'RO',
        clientId: 'EvekgodGkFY4FUR3TqESMA0I',
        clientSecret: '6HNLB47W24AElP8alKUamRyTxgafELpK',
        projectKey: 'global-mr-prd',
      },
      features: {
        ...baseConfig.features,
        enableCartOptimisticResponse: true,
        displayLinkToPDP: true,
        crossSelling: true,
      },
    },
  },
};

export default config;
